module.exports = __webpack_public_path__ + "img/50d.40d7b29b.svg";